import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { ApiClientProvider } from "./context/ApiClientContext";
// import { LicenseInfo } from '@mui/x-license';

import { ToastBar, Toaster } from "react-hot-toast";
import CustomTheme from "./theme/customTheme";

// LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <ThemeProvider theme={CustomTheme}>
      <GlobalStyles
        styles={{
          html: { overflow: "hidden", height: "100vh", margin: 0, padding: 0 },
          body: { overflow: "hidden", height: "100vh", margin: 0, padding: 0 },
          "#root": { height: "100vh" }, // if you're using React root div
        }}
      />
      <CssBaseline />

      <ApiClientProvider>
        <App />
        <Toaster
          position="top-center"
          gutter={8}
          containerStyle={{
            top: 20,
          }}
          toastOptions={{
            // 🌍 Global styles (apply to all toasts)
            style: {
              border: "1px solid #39493F",
              padding: "8px",
              color: "#39493F",
              backgroundColor: "#CBCEA7",
              width: "90vw",   // default for mobile
              maxWidth: "500px",
              textAlign: "left"   // 👈 responsive on mobile
            },
            // ✅ Success toast
            success: {
              style: {
                background: "#4BB543",
                color: "white",
              },
              iconTheme: {
                primary: "white",
                secondary: "#4BB543",
              },
            },
            // ❌ Error toast
            error: {
              style: {
                background: "#FF3333",
                color: "white",
              },
              iconTheme: {
                primary: "white",
                secondary: "#FF3333",
              },
            },
            // ⏳ Loading toast
            loading: {
              style: {
                background: "#CBCEA7",
                color: "black",
              },
            },
          }}
        >
          {(t) => (
            <ToastBar
              toast={t}
              style={{
                ...t.style,
                justifyContent: "flex-start", // 👈 aligns everything left

                animation: t.visible
                  ? "custom-enter 0.4s ease-out"
                  : "custom-exit 0.4s ease-in",
              }}
            />
          )}
        </Toaster>

      </ApiClientProvider>
    </ThemeProvider>
);
